export * from "./APIErrors";

export function createConstants(...constants) {
  return constants.reduce((acc, constant) => {
    acc[constant] = constant;
    return acc;
  }, {});
}

export function checkHttpStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

export function parseJSON(response) {
  return response.json();
}

export function rolePerms(role) {
  const storedRoles = JSON.parse(sessionStorage.getItem("roles"));

  if (
    storedRoles.map((r) => r.toLowerCase()).indexOf(role.toLowerCase()) !== -1
  ) {
    return true;
  }

  return false;
}

export function userPermissions(permission) {
  const storedPermissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (storedPermissions?.map((p) => p).indexOf(permission) !== -1) {
    return true;
  }

  return false;
}

export function capitalize(value) {
  return value[0].toUpperCase() + value.substring(1);
}
